import { render, staticRenderFns } from "./UserProfileSettings.vue?vue&type=template&id=7160022b&scoped=true&"
import script from "./UserProfileSettings.vue?vue&type=script&lang=js&"
export * from "./UserProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileSettings.vue?vue&type=style&index=0&id=7160022b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7160022b",
  null
  
)

export default component.exports